import * as config from "../../../app.config";
import { setHeaders } from '../../../actions/User';
import { useQuery } from 'react-query';
import axios from 'axios';


const getSingleWellColorAnalysis = async (plate_uuid) => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS.datalake}/qc/analysis/color_calibration_analysis/${plate_uuid}`,
        {
            headers: headerConfig
        });

    //  console.log({ data });
    return data;
}

export default function useFetchSingleWellColorAnalysis(plate_uuid, options = {}) {
    return useQuery(['SingleWellColorAnalysis', plate_uuid], () => getSingleWellColorAnalysis(plate_uuid), options);
    // , {
    //     onSuccess: (data) => {
    //         setAnalysisResults(data);
    //         setTabValue("tab4");
    //         console.log(data);
    //     },
    //     onError: (error) => {
    //         console.log(error);
    //     }
    // });
}